// extracted by mini-css-extract-plugin
export default {"container":"Dictionary_container__uztex","blocktitle":"Dictionary_blocktitle__2bDIZ","title":"Dictionary_title__zIUoW","article":"Dictionary_article__wpY3c"};